export default "__VITE_ASSET__CyEY5zkA__"